"use client";

import { useState } from "react";
import Button from "../components/Button";
import ChartImage from "../assets/chart_1.png";
import ChartImage2 from "../assets/chart_2.png";
import BannerImage from "../assets/banner_image.png";
import Counter from "../components/Counter";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/auth/register");
  };
  return (
    <section id="hero-section" className="w-full relative min-h-screen ">
      <div className="container mt-16 pt-16 mx-auto flex flex-col items-center justify-center gap-4">
        <h1 className="">
          Smarter Investment, Brighter <br /> Spending with FinAI
        </h1>
        <p className="">
          Establish your vision and value proposition and turn them
          <br /> into testable prototypes.
        </p>
        <div className="flex flex-row gap-4 items-center mb-8">
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Enter your e-mail"
            className="border px-3 py-2 rounded"
          />
          <Button variant="contact" onClick={handleClick}>
            Get Started
          </Button>
        </div>
      </div>

      {/* Image and animations */}
      <div className="flex flex-col-reverse">
        {/* Banner Image */}
        <div className="relative w-full h-max mt-24">
          <div className="absolute top-0 left-0 w-full h-full z-0 flex items-end shape"></div>
          <div className="absolute top-0 left-0 w-full h-full z-10 flex items-end justify-center">
            <img id="banner_image" src={BannerImage} alt="banner_image" />
          </div>
        </div>

        {/* Animated Charts */}
        <div className="flex flex-row justify-center items-center gap-4 mt-8 md:mt-0">
          <img
            id="chart-1"
            src={ChartImage}
            alt="Chart"
            className="
      w-36 sm:w-48 h-auto animate-float 
      md:w-52 lg:w-60 md:absolute 
      md:top-1/2 md:right-4 
      lg:right-4 xl:right-16
    "
          />
          <img
            id="chart-2"
            src={ChartImage2}
            alt="Chart 2"
            className="
      w-36 sm:w-48 h-auto animate-sway 
      md:w-52 lg:w-60 md:absolute 
      md:top-1/2 md:left-4 
      lg:left-10 xl:left-16
    "
          />
        </div>
      </div>
    </section>
  );
}
